import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { BrownfieldState } from './types'

export const initialState: BrownfieldState = {
  skipTokenExchange: false,
}

const brownfieldSlice = createSlice({
  name: 'brownfield',
  initialState,
  reducers: {
    /**
     * Sets the `skipTokenExchange` auth flag. Set from native bootstrap props
     * (`App/Containers/App/index.tsx`) so the JS startup saga knows whether to call
     * `loginWithExchangeToken` or fall back to the existing Dialogue auth token.
     */
    setSkipTokenExchange: (state, action: PayloadAction<boolean>) => {
      state.skipTokenExchange = action.payload
    },
    /** Clears the auth-only skip flag after brownfield full startup. */
    clearSkipTokenExchange: (state) => {
      state.skipTokenExchange = false
    },
  },
})

export const brownfieldActions = brownfieldSlice.actions

export const selectSkipTokenExchange = (state: { brownfield?: BrownfieldState } | undefined) =>
  Boolean(state?.brownfield?.skipTokenExchange)

export default brownfieldSlice.reducer
